module.exports = __webpack_public_path__ + "static/media/checklist_ikon.0675d8b9.svg";